// extracted by mini-css-extract-plugin
module.exports = {"wrap":"G3av","imgBg":"G3abf","image":"G3ob","textBox":"G3abh","title":"G3al","advLabel":"G3kh"};